var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolAppBookingRescheduling01 = function SvgSolAppBookingRescheduling01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_app_booking_rescheduling-01_svg2__a",
    x1: -9.84,
    x2: 117.22,
    y1: 152.73,
    y2: -25.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#f434e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#dd1de7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#cd0ce8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c403e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c100e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__b",
    x1: 10.89,
    x2: 137.95,
    y1: 167.49,
    y2: -10.95
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__c",
    x1: 31.63,
    x2: 158.69,
    y1: 182.26,
    y2: 3.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__d",
    x1: 52.37,
    x2: 179.43,
    y1: 197.02,
    y2: 18.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__e",
    x1: 4.92,
    x2: 131.98,
    y1: 163.24,
    y2: -15.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__f",
    x1: 25.66,
    x2: 152.72,
    y1: 178.01,
    y2: -0.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__g",
    x1: 19.69,
    x2: 146.75,
    y1: 173.75,
    y2: -4.69
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__h",
    x1: 40.42,
    x2: 167.48,
    y1: 188.52,
    y2: 10.07
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__i",
    x1: 46.4,
    x2: 173.45,
    y1: 192.77,
    y2: 14.32
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__j",
    x1: 12.33,
    x2: 139.39,
    y1: 168.52,
    y2: -9.93
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__k",
    x1: 105.59,
    x2: 232.65,
    y1: 234.92,
    y2: 56.47
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_app_booking_rescheduling-01_svg2__a",
    id: "sol_app_booking_rescheduling-01_svg2__l",
    x1: 103.5,
    x2: 230.56,
    y1: 233.43,
    y2: 54.98
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 87.5H25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h18.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 87.5H56.25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12H75c1.73 0 3.12-1.4 3.12-3.12S76.72 87.5 75 87.5",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25 87.5H87.5c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h18.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5 93.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-18.75c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12z",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 118.75H25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h18.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 118.75H56.25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12H75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.75 150H25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h18.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 150H56.25c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12H75c1.73 0 3.12-1.4 3.12-3.12S76.72 150 75 150",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25 118.75H87.5c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h18.75c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.06 175H15.62c-5.17 0-9.38-4.21-9.38-9.38V62.5h134.38c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12H6.25V34.38c0-5.17 4.21-9.38 9.38-9.38h12.5v6.25c0 6.89 5.61 12.5 12.5 12.5h6.25c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-6.25c-3.45 0-6.25-2.8-6.25-6.25V12.5c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25h-3.12c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h65.62v6.25c0 6.89 5.61 12.5 12.5 12.5h6.25c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12h-6.25c-3.45 0-6.25-2.8-6.25-6.25V12.5c0-3.45 2.8-6.25 6.25-6.25s6.25 2.8 6.25 6.25v6.25h-3.12c-1.73 0-3.12 1.4-3.12 3.12s1.4 3.12 3.12 3.12h21.88c5.17 0 9.38 4.21 9.38 9.38v59.38c0 1.73 1.4 3.12 3.12 3.12s3.12-1.4 3.12-3.12V34.37c0-8.62-7.01-15.62-15.62-15.62h-12.5V12.5c0-6.89-5.61-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25H53.14V12.5c0-6.89-5.61-12.5-12.5-12.5s-12.5 5.61-12.5 12.5v6.25h-12.5C7.02 18.75.02 25.76.02 34.37v131.25c0 8.62 7.01 15.62 15.62 15.62h97.43c1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.88 156.25c-1.73 0-3.12 1.4-3.12 3.12 0 18.95-15.42 34.38-34.38 34.38S125 178.33 125 159.37s15.42-34.38 34.38-34.38h1.83l-4.04 4.04a3.126 3.126 0 0 0 0 4.42c.61.61 1.41.92 2.21.92s1.6-.31 2.21-.92l9.38-9.38a3.126 3.126 0 0 0 0-4.42l-9.38-9.38a3.126 3.126 0 0 0-4.42 4.42l4.04 4.04h-1.83c-22.4 0-40.62 18.22-40.62 40.62s18.22 40.62 40.62 40.62S200 181.75 200 159.35c0-1.73-1.4-3.12-3.12-3.12Z",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.62 159.38c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12c0 13.78 11.22 25 25 25 1.73 0 3.12-1.4 3.12-3.12s-1.4-3.12-3.12-3.12c-10.34 0-18.75-8.41-18.75-18.75Z",
    style: {
      fill: "url(#sol_app_booking_rescheduling-01_svg2__l)"
    }
  }));
};
export default SvgSolAppBookingRescheduling01;